export default "__VITE_ASSET__Dg___JeA__"